var featureBrand = [
  {
    id: 1,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645075700/kx90tgnajdjxrltg0w8q.png",
    name: "Dabur Products",
    link: "https://www.1mg.com/categories/featured/top-brands/dabur-products-771",
  },
  {
    id: 2,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645336011/x1fsuvkfmp5gbidg2ztd.png",
    name: "Himalaya Products",
    link: "https://www.1mg.com/categories/top-brands/himalaya-wellness-healthcare-products-241",
  },
  {
    id: 3,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645502869/xodvnn77yblipffhaeg8.jpg",
    name: "Pediasure",
    link: "https://www.1mg.com/categories/fitness-supplements/protein-supplements/pediasure-436",
  },
  {
    id: 4,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645502885/jsr89gywaswejlw0tzb8.png",
    name: "Cenvitan Multivitamins",
    link: "https://www.1mg.com/categories/featured/top-brands/healthvit-cenvitan-385",
  },
  {
    id: 5,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645502901/npwnkuyn3jcnoouaqdto.png",
    name: "Baidyanath",
    link: "https://www.1mg.com/categories/ayurveda/top-brands/baidyanath-products-417",
  },
  {
    id: 6,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645420128/rfvnpy3qt4tnacj5ecvk.jpg",
    name: "Accu-Chek",
    link: "https://www.1mg.com/categories/diabetes/accu-chek-273",
  },
  {
    id: 7,
    image_url:
      "https://onemg.gumlet.io/image/upload/w_150,h_150,c_fit,a_ignore,q_auto,f_auto/v1645502918/jbzzfzq1hglq5nkllrjo.png",
    name: "Contour",
    link: "https://www.1mg.com/categories/featured/top-brands/contour-268",
  },
];

// localStorage.setItem("featurebrands",JSON.stringify(featureBrand))

export default featureBrand;
